import Component from '../../../../../../../../../lib/component';
import template from './calendar.small.day.html';
import './calendar.small.day.scss'
import Mediator from "../../../../../../../../../lib/mediator";
let config = {
    template: template,
    data: {
    },
    binds:[
        {
            event:'click',
            selector:'.date-gird span',
            callback:function(context,event){
                console.log(context,'context')
                let time = $(context).attr('data-id');
                let data = null;
                this.data.dayList.forEach(function (val) {
                    if(val.dataTime === time){
                        data = val;
                        return true;
                    }
                })
                $(context).parents('.calendar-main').find('.today-span').removeClass('today-span');
                $(context).addClass('today-span')
                if(data){
                    Mediator.emit('CalendarSmall: changeData',{data: data,time:time});
                }
            }
        },
    ],
    actions: {},
    beforeRender(){
    },
    afterRender() {
    },
    firstAfterRender() {}
};
let smallCalendarDay= Component.extend(config);
export default smallCalendarDay;


// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.day/calendar.small.day.js